<template>
  <el-dialog title="配置合格证书" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
    <el-form :model="form" :rules="rule" ref="form">
      <el-form-item label="培训班名称" :label-width="formLabelWidth">
        <el-input readonly v-model="editParams.skuName" autocomplete="off" placeholder="请输入培训班名称"></el-input>
      </el-form-item>
      <el-form-item label="证书选择" :label-width="formLabelWidth" prop="qualityId">
        <el-select v-model="form.qualityId" @change='change'>
          <el-option v-for="(item,idx) in selectJson" :key="idx" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="red">
        请谨慎选择合格证模版，如果更换合格证模版，请在培训班通讯录中，为学员重新生成合格证
      </div>
      <el-form-item label="证书样例" :label-width="formLabelWidth">
        <img :src="imgUrl" alt="" style="max-width:300px">
      </el-form-item>
    </el-form>
    <el-alert title="证书编号" type="success" :closable="false" />
    <br />
    <el-table :data="list" border>
      <el-table-column label="租户名称" align="center" prop="companyName" min-width="180" :formatter="fliteRData" />
      <el-table-column label="当前年份" align="center" prop="numberYearNow" min-width="180">
        <template v-slot="{ row }">
          <el-input v-model="row.numberYearNow" placeholder="当前年份" @blur="updateList('numberYearNow',row)" />
        </template>
      </el-table-column>
      <el-table-column label="岗位名称" align="center" prop="numberPost" min-width="180">
        <template v-slot="{ row }">
          <el-input v-model="row.numberPost" placeholder="岗位名称" @blur="updateList('numberPost',row)" />
        </template>
      </el-table-column>
      <el-table-column label="合同签订年" align="center" prop="numberYearSign" min-width="180">
        <template v-slot="{ row }">
          <el-input v-model="row.numberYearSign" placeholder="合同签订年" @blur="updateList('numberYearSign',row)" />
        </template>
      </el-table-column>
      <el-table-column label="合同编号" align="center" prop="numberContract" min-width="180">
        <template v-slot="{ row }">
          <el-input v-model="row.numberContract" placeholder="合同编号" @blur="updateList('numberContract',row)" />
        </template>
      </el-table-column>
      <el-table-column label="证书起始编号" align="center" prop="numberStartStr" min-width="180">
        <template slot="header">
          <span>证书起始编号</span>
          <el-tooltip class="item" effect="dark" content="证书起始编号位数越多，可颁发证书编号上限约高">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template v-slot="{ row }">
          <el-input v-model="row.numberStartStr" placeholder="证书起始编号" @blur="updateList('numberStartStr',row)" />
        </template>
      </el-table-column>
      <el-table-column label="学员证书编号预览" align="center" min-width="180">
        <template v-slot="{ row }">
          {{row.numberYearNow}}{{row.numberPost}}{{row.numberYearSign}}{{row.numberContract}}{{row.numberStartStr}}
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import tableMixins from "@/libs/mixins/table"
import { skuupdate,getCertificateInfo, skuCertificatepage, skuCertificateupdate } from "@/api/product/classManage"
export default {
  components: {},
  mixins: [tableMixins],
  props: {
    editParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgUrl: '',
      dialogVisible: false,
      formLabelWidth: "130px",
      selectJson: [
        {
          label: '123',
          value: '0'
        }
      ],
      form: {},
      rule: {
        qualityId: [{ required: true, message: "请选择证书类型", trigger: "blur" }],
      },
      list: []
    };
  },
  methods: {
    async getData () {
      const params = {
        type: 1,
        ...this.pageInfo,
        skuId: this.editParams.id,
      }
      const res = await skuCertificatepage(params)
      this.total = Number(res.data.total)
      this.list = res.data.records.map(item => {
        item.numberYearNow = item.numberYearNow || ''
        item.numberPost = item.numberPost || ''
        item.numberYearSign = item.numberYearSign || ''
        item.numberContract = item.numberContract || ''
        item.numberStartStr = item.numberStartStr || ''
        return { ...item }
      })
    },
    async updateList (key, item) {
      const type = 1
      const value = item[key]
      // if (value == '') return
      const companyId = item.companyId
      const skuId = this.editParams.id
      const numberYearNow = item.numberYearNow
      const numberPost = item.numberPost
      const numberYearSign = item.numberYearSign
      const numberContract = item.numberContract
      const numberStartStr = item.numberStartStr
      const obj = { numberYearNow, numberPost, numberYearSign, numberContract, numberStartStr }
      let res
      try {
        switch (key) {
        case 'numberYearNow':
          res = await skuCertificateupdate([{ ...obj, numberYearNow: value, companyId, skuId, type }])
          break;
        case 'numberPost':
          res = await skuCertificateupdate([{ ...obj, numberPost: value, companyId, skuId, type }])
          break;
        case 'numberYearSign':
          res = await skuCertificateupdate([{ ...obj, numberYearSign: value, companyId, skuId, type }])
          break;
        case 'numberContract':
          res = await skuCertificateupdate([{ ...obj, numberContract: value, companyId, skuId, type }])
          break;
        case 'numberStartStr':
          res = await skuCertificateupdate([{ ...obj, numberStartStr: value, companyId, skuId, type }])
          break;
        default:
          break;
        }
        if (res.data) {
          this.$confirm(`${res.data}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getData()
          }).catch(() => {
            this.getData()
          });
        }
      } catch (err) {
        this.getData()
      }
    },
    change (id) {
      console.log(id)
      this.selectJson.map((item) => {
        if (item.id == id) {
          this.imgUrl = item.templateUrl
        }
      })
    },
    setOpacity (flg) {
      this.getSelectData();
      this.getData()
      this.dialogVisible = flg;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    getSelectData () {
      getCertificateInfo({
        templateType: 2
      }).then(res => {
        let { code, data, message } = res;
        if (code === 0) {
          this.selectJson = data;
          this.change(this.form.qualityId)
        } else {
          this.$message.error(message);
        }
      })
    },
    sure () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
           const params = {
            id:this.editParams.id,
            certificateQualifiedId: this.form.qualityId,
          }
          skuupdate(params).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$emit('success')
              this.$message.success('配置成功');
              this.dialogVisible = false
            } else {
              this.$message.error(message);
            }
          })
        }
      })

    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          this.imgUrl = ''
          if (this.editParams.certificateQualifiedId !== undefined) {
            this.form.qualityId = Number(this.editParams.certificateQualifiedId)
          } else {
            this.form = {}
          }
        }

      },
    },
  },
};
</script>

<style lang="scss">
.w50 {
  width: 50%;
  display: inline-block;
}
.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
